import { useCallback, useEffect, useMemo, useState } from 'react';
import { cable } from '../../../../plugins/cable';

import { Broadcast, Message as IMessage, useGetChatMessagesQuery } from '../../../../features/api/apiSlice';
import { Consumer } from '@rails/actioncable';
import { Platform } from '../../../../features/api/apiSlice';

interface UseChatParams {
  broadcastId: Broadcast['id'];
}

export interface SendMessageParams {
  message?: IMessage['message'];
  captchaSid?: number;
  captchaKey?: string;
  retryPlatform?: Platform;
}

const cableSocket: Consumer = cable();

export const useChat = ({ broadcastId }: UseChatParams) => {
  const [ errorMessage, setErrorMessage ] = useState<IMessage | null>(null);
  const [ messages, setMessages ] = useState<IMessage[]>([]);
  // * Get messages from chat
  const { isSuccess, data: fetchedMessages, refetch: refetchMessages } = useGetChatMessagesQuery({
    id: String(broadcastId)
  });

  const consumer = useMemo(() => {
    return cableSocket.subscriptions.create(
      { channel: "ChatChannel", room: `Room_${broadcastId}`, broadcast_id: broadcastId},
      {
        connected() {
          console.log('Chat connected.');
        },
        received(data: IMessage) {
          // Делаем проверку на наличие поля капчи, т.к может быть ошибка "unknown error"
          if(data.error?.captcha_sid) {
            setErrorMessage(data);
            return;
          }

          // Проверяем, что в данных есть message, чтоб не выводить пустое сообщение
          if(!data.message) return;

          setMessages((state) => {
              return [...state, data];
          });
        }
      }
    );
  }, [broadcastId]);


  useEffect(() => {
    if (isSuccess) {
      const reversedMessages = [...fetchedMessages.response].reverse();
      setMessages([...messages, ...reversedMessages]);
    }
  }, [setMessages, fetchedMessages, isSuccess]);

  const sendMessage = useCallback(({ message, captchaSid, captchaKey, retryPlatform }: SendMessageParams) => {
    consumer.send({
      message,
      captcha_sid: captchaSid,
      captcha_key: captchaKey,
      retry_platform: retryPlatform,
      broadcast_id: broadcastId
    });
  }, [consumer, broadcastId]);

  return { messages, errorMessage, sendMessage, setErrorMessage, refetchMessages };
};